<!-- results-table.component.html -->
<h1 mat-dialog-title>
    <strong>{{ action | translate }}</strong> operación
    <span *ngIf="action == 'Delete'"> {{ LOCAL_DATA.nombre }}</span>
</h1>
<div mat-dialog-content fxLayout="column">
    <mat-horizontal-stepper [linear]="true" #stepper *ngIf="action != 'Delete'">
        <mat-step *ngIf="showNewClient">
            <ng-template matStepLabel>Cliente</ng-template>
            <mat-tab-group>
                <mat-tab
                    label="Seleccionar cliente existente"
                    *ngIf="clientes != null && clientes.length > 0"
                >
                    <div fxLayout="column">
                        <mat-form-field
                            *ngIf="action != 'Delete'"
                            class="select-list"
                        >
                            <mat-label>Cliente</mat-label>
                            <mat-select
                                [(ngModel)]="LOCAL_DATA.cliente"
                                class="roleSelect"
                                [disabled]="action == 'View'"
                                [compareWith]="compareObjects"
                                (selectionChange)="clienteChange($event.value)"
                            >
                                <mat-option
                                    *ngFor="let cliente of clientes"
                                    [value]="cliente"
                                >
                                    {{ cliente.nombre }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </mat-tab>

                <mat-tab label="Nuevo cliente" *ngIf="showNewClient">
                    <cliente
                        [action]="action"
                        [cliente]="LOCAL_DATA.cliente"
                        (onClienteChange)="clienteChange($event)"
                        [eventoRecibido]="eventoDesdePadre"
                    ></cliente>
                    <!-- <button (click)="enviarEventoAlHijo()">Enviar evento al hijo</button> -->
                </mat-tab>
            </mat-tab-group>
            <!-- 
      
      <div fxLayout="column"  *ngIf="clientes!=null && clientes.length>0">
        <h4>Selecciona un cliente</h4>
        <mat-form-field *ngIf="action != 'Delete'" class="select-list">
          <mat-label>Cliente</mat-label>
          <mat-select [(ngModel)]="LOCAL_DATA.cliente" class="roleSelect"
              [disabled]="action == 'View'" [compareWith]="compareObjects">
              <mat-option *ngFor="let cliente of clientes" [value]="cliente">
                  {{cliente.nombre}}
              </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <h4>Nuevo cliente</h4>
      <cliente [action]="action" [cliente]="LOCAL_DATA.cliente" (clienteChange)="clienteChange($event)"></cliente>
       -->

            <div fxFlex="100" fxLayoutAlign="end end" class="p-24">
                <button
                    mat-button
                    (click)="closeDialog()"
                    mat-flat-button
                    color="warn"
                >
                    {{ "Cancel" | translate }}
                </button>
                <button
                    mat-button
                    matStepperNext
                    (click)="enviarEventoAlHijo()"
                >
                    Siguiente
                </button>
            </div>
        </mat-step>
        <mat-step label="Datos de la operación">
            <div fxLayout="column">
                <mat-checkbox
                    class="example-margin"
                    [(ngModel)]="LOCAL_DATA.actuaEnNombreDeTercero"
                    >Actua en nombre de un tercero?</mat-checkbox
                >
            </div>

            <div fxLayout="column">
                <mat-form-field *ngIf="action != 'Delete'" class="select-list">
                    <mat-label>País de la operación</mat-label>
                    <mat-select
                        [(ngModel)]="LOCAL_DATA.pais"
                        class="roleSelect"
                        [disabled]="action == 'View'"
                        [required]="true"
                        [compareWith]="compareObjects"
                    >
                        <mat-option *ngFor="let pais of paises" [value]="pais">
                            {{ pais.nombre }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <div fxLayout="column">

                <mat-form-field *ngIf="action != 'Delete'" class="select-list">
                    <mat-label *ngIf="origenFondos.length>0">Origen de fondos</mat-label>
                    <mat-label *ngIf="origenFondos.length==0">No existen origen de fondos disponibles</mat-label>
                    <mat-select
                        [(ngModel)]="LOCAL_DATA.origenDeFondos"
                        class="roleSelect"
                        [disabled]="action == 'View'"
                        [compareWith]="compareObjects"
                        [required]="true"
                    >
                        <mat-option
                            *ngFor="let origen of origenFondos"
                            [value]="origen"
                        >
                            {{ origen.nombre }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <div fxLayout="column">
                <mat-form-field *ngIf="action != 'Delete'" class="select-list">
                    <mat-label *ngIf="tiposDeOperacion.length>0">Tipo de operación</mat-label>
                    <mat-label *ngIf="tiposDeOperacion.length==0">No existen tipo de operación disponibles</mat-label>
                    <mat-select
                        [(ngModel)]="LOCAL_DATA.tipoOperacion"
                        class="roleSelect"
                        [disabled]="action == 'View'"
                        [compareWith]="compareObjects"
                        [required]="true"
                    >
                        <mat-option
                            *ngFor="let tipo of tiposDeOperacion"
                            [value]="tipo"
                        >
                            {{ tipo.nombre }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <div fxLayout="column">
                <mat-form-field *ngIf="action != 'Delete'" class="select-list">
                    <mat-label *ngIf="tiposSectorIndustrial.length>0">Sector de actividad</mat-label>
                    <mat-label *ngIf="tiposSectorIndustrial.length==0">No existen sector de actividad disponibles</mat-label>
                    <mat-select
                        [(ngModel)]="LOCAL_DATA.sectorIndustrial"
                        class="roleSelect"
                        [disabled]="action == 'View'"
                        [compareWith]="compareObjects"
                    >
                        <mat-option
                            *ngFor="let tipo of tiposSectorIndustrial"
                            [value]="tipo"
                        >
                            {{ tipo.nombre }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <div fxLayout="column">
                <mat-form-field
                    color="accent"
                    appearance="fill"
                    *ngIf="action != 'Delete'"
                >
                    <mat-label>Vigencia de la operación</mat-label>
                    <input
                        matInput
                        [matDatepicker]="picker1"
                        [(ngModel)]="LOCAL_DATA.fechaVencimiento"
                        [disabled]="action == 'View'"
                    />
                    <mat-datepicker-toggle
                        matSuffix
                        [for]="picker1"
                    ></mat-datepicker-toggle>
                    <mat-datepicker #picker1></mat-datepicker>
                </mat-form-field>
            </div>

            <div fxLayout="row">
                <mat-form-field fxFlex="50">
                    <!-- <input placeholder="Monto" matInput [(ngModel)]="LOCAL_DATA.monto" [disabled]="action == 'View'" > -->
                    <input
                        placeholder="Monto"
                        matInput
                        [(ngModel)]="LOCAL_DATA.monto"
                        type="number"
                        step=".01"
                        [disabled]="action == 'View'"
                        [required]="true"
                    />
                </mat-form-field>

                <mat-form-field
                    *ngIf="action != 'Delete'"
                    class="select-list"
                    fxFlex="50"
                >
                    <mat-label>Moneda de la operación</mat-label>
                    <mat-select
                        [(ngModel)]="LOCAL_DATA.moneda"
                        class="roleSelect"
                        [disabled]="action == 'View'"
                        [compareWith]="compareObjects"
                        [required]="true"
                    >
                        <mat-option *ngFor="let tipo of monedas" [value]="tipo">
                            {{ tipo.nombre }} {{ tipo.simbolo }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div fxLayout="row">
                {{ LOCAL_DATA.moneda?.simbolo }}
                {{ LOCAL_DATA.monto | number : "1.2-3" : "es" }}
            </div>

            <div
                mat-dialog-actions
                fx-layout="row"
                fx-flex
                fxLayoutAlign="end end"
                class="p-24"
            >
                <button
                    mat-button
                    (click)="closeDialog()"
                    mat-flat-button
                    color="warn"
                >
                    {{ "Cancel" | translate }}
                </button>
                <button
                    mat-button
                    matStepperNext
                    (click)="enviarEventoAlHijoBeneficiario()"
                >
                    Siguiente
                </button>
            </div>
        </mat-step>

        <mat-step
            label="Datos del beneficiario"
            *ngIf="LOCAL_DATA.actuaEnNombreDeTercero"
        >
            <cliente
                [action]="action"
                [cliente]="LOCAL_DATA.beneficiario"
                [(tipo)]="LOCAL_DATA.beneficiario.tipo"
                (onClienteChange)="beneficiarioChange($event)"
                [eventoRecibido]="eventoDesdePadre"
            ></cliente>

            <div fxFlex="100" fxLayoutAlign="end end" class="p-24">
                <button
                    mat-button
                    (click)="closeDialog()"
                    mat-flat-button
                    color="warn"
                >
                    {{ "Cancel" | translate }}
                </button>
                <button mat-button matStepperPrevious>Anterior</button>
                <button mat-button matStepperNext>Siguiente</button>
            </div>
        </mat-step>
        <mat-step>
            <ng-template matStepLabel>Análisis de riesgos</ng-template>

            <div fxLayout="column">
                <mat-form-field
                    *ngIf="action != 'Delete'"
                    class="select-list"
                >
                    <mat-label *ngIf="ponderacionesDeRiesgos.length>0">Ponderación de riesgos</mat-label>
                    <mat-label *ngIf="ponderacionesDeRiesgos.length==0">No existen Ponderación de riesgos disponibles</mat-label>
                    <mat-select
                        [(ngModel)]="LOCAL_DATA.ponderacionDeRiesgos"
                        class="roleSelect"
                        [disabled]="action == 'View'"
                        [compareWith]="compareObjects"
                    >
                        <mat-option
                            *ngFor="let ponderacion of ponderacionesDeRiesgos"
                            [value]="ponderacion"
                        >
                            {{ ponderacion.nombre }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <div fxLayout="column" fxFlex="100">
                <ponderacion-de-riesgos-results-table [debidaDiligencia]="LOCAL_DATA"  (totalCalculoChange)="onTotalCalculoChange($event)" [ponderacionDeRiesgos]="LOCAL_DATA.ponderacionDeRiesgos" ></ponderacion-de-riesgos-results-table>
            </div>

              <div  fxFlex="100" fxLayoutAlign="end end" class="p-24">
                <button mat-button (click)="closeDialog()" mat-flat-button color="warn">{{'Cancel' | translate}}</button>
                <button mat-button matStepperPrevious>Anterior</button>
                <button mat-button matStepperNext>Siguiente</button>

              </div>
          </mat-step>
        <mat-step>
            <ng-template matStepLabel>Solicitud de información</ng-template>

            <div fxLayout="column">
                <div fxLayout="column" class="p-24">
                    <div fxLayout="row" class="p-5">
                        <h3>Destinatarios</h3>
                        <!--aligne content right-->
                        <div fxFlex="100" fxLayoutAlign="end end">
                            <button
                                mat-button
                                (click)="openDialogDestinatario('Add', {})"
                                mat-flat-button
                                color="primary"
                                class="add-row"
                            >
                                Agregar
                            </button>
                        </div>
                    </div>

                    <div fxLayout="row">
                        <table
                            mat-table
                            [dataSource]="LOCAL_DATA.destinatarios"
                            #mytable
                            class="my-table mat-elevation-z8"
                            fxFlex="100"
                        >
                            <!--- Note that these columns can be defined in any order.
              The actual rendered columns are set as a property on the row definition" -->

                            <!-- User Column -->
                            <ng-container matColumnDef="nombre">
                                <th mat-header-cell *matHeaderCellDef>
                                    Nombre
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    {{ element.nombre }}
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="apellido">
                                <th mat-header-cell *matHeaderCellDef>
                                    Apellido
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    {{ element.apellido }}
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="correoElectronico">
                                <th mat-header-cell *matHeaderCellDef>
                                    Correo Electronico
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    {{ element.correoElectronico }}
                                </td>
                            </ng-container>

                            <!-- Action Column -->
                            <ng-container matColumnDef="action">
                                <th mat-header-cell *matHeaderCellDef>
                                    Acción
                                </th>
                                <td
                                    mat-cell
                                    *matCellDef="let element"
                                    class="action-link"
                                >
                                    <a
                                        (click)="
                                            openDialogDestinatario(
                                                'Update',
                                                element
                                            )
                                        "
                                        >Editar</a
                                    >
                                    <span>| </span>
                                    <a
                                        (click)="
                                            openDialogDestinatario(
                                                'Delete',
                                                element
                                            )
                                        "
                                        >Eliminar</a
                                    >
                                </td>
                            </ng-container>

                            <tr
                                mat-header-row
                                *matHeaderRowDef="displayedColumnsDestinatarios"
                            ></tr>
                            <tr
                                mat-row
                                *matRowDef="
                                    let row;
                                    columns: displayedColumnsDestinatarios
                                "
                            ></tr>
                        </table>
                    </div>
                </div>
            </div>

            <div fxFlex="100"  class="p-24">
                <b>Tipo de debida diligencia:</b> <span *ngIf="totalCalculo >= LOCAL_DATA.ponderacionDeRiesgos?.toleranciaAlRiesgo" style="margin-left: 20px">Ampliada</span>
                <span *ngIf="totalCalculo < LOCAL_DATA.ponderacionDeRiesgos?.toleranciaAlRiesgo" style="margin-left: 20px">Simplificada</span>
            </div>

            <div fxLayout="column" class="p-24">
                <mat-form-field *ngIf="action != 'Delete'" class="select-list">
                    <mat-label *ngIf="formularios.length>0">Formulario</mat-label>
                    <mat-label *ngIf="formularios.length==0">No existen Formularios disponibles</mat-label>

                    <mat-select
                        [(ngModel)]="LOCAL_DATA.formulario"
                        class="roleSelect"
                        [disabled]="action == 'View'"
                        [compareWith]="compareObjects"
                        (selectionChange)="setFormulario()"
                    >
                        <mat-option
                            *ngFor="let formulario of formularios"
                            [value]="formulario">
                            <!--[disabled]="(formulario.tipo === 'SIMPLIFICADA' && totalCalculo >= LOCAL_DATA.ponderacionDeRiesgos?.toleranciaAlRiesgo)"-->

                            {{ formulario.nombre }} - {{ formulario.tipo }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <div class="content p-24" fxFlex="100">
                <div fxLayout="row" fxLayoutAlign="end end">
                    <button
                        mat-button
                        (click)="openDialog('Add', {})"
                        mat-flat-button
                        color="primary"
                        class="add-row"
                        *ngIf="
                            action != 'View' &&
                            action != 'Duplicate' &&
                            isFormLoaded
                        "
                    >
                        Agregar / Modificar Sentencias
                    </button>
                </div>

                <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
                    <!-- This is the tree node template for leaf nodes -->
                    <mat-tree-node
                        *matTreeNodeDef="let node"
                        matTreeNodePadding
                    >
                        <!-- use a disabled button to provide padding for tree leaf -->
                        <button mat-icon-button disabled></button>
                        <span style="font-weight: bold; margin-right: 5px">{{
                            node.name
                        }}</span>
                        <span
                            *ngIf="
                                node.descripcion != null &&
                                node.descripcion != ''
                            "
                            style="margin-right: 5px"
                        >
                            | {{ node.descripcion }}</span
                        >
                        <span
                            *ngIf="
                                node.opcion != null && node.opcion?.nombre != ''
                            "
                            style="margin-right: 5px"
                        >
                            | {{ node.opcion?.nombre }}</span
                        >
                        <span
                            *ngIf="node.tipo != null && node.tipo != ''"
                            style="margin-right: 5px"
                        >
                            | {{ node.tipo }}</span
                        >
                        <!--
            <span *ngIf="node.palabrasClave!=null && node.palabrasClave.length>0" style="font-weight: bold;margin-right:5px;"> | </span>
            <mat-chip-list aria-label="Palabras Clave" *ngIf="node.palabrasClave!=null && node.palabrasClave.length>0">
              <mat-chip *ngFor="let palabra of node.palabrasClave">{{palabra}}</mat-chip>
            </mat-chip-list>-->
                    </mat-tree-node>
                    <!-- This is the tree node template for expandable nodes -->
                    <mat-tree-node
                        *matTreeNodeDef="let node; when: hasChild"
                        matTreeNodePadding
                    >
                        <button
                            mat-icon-button
                            matTreeNodeToggle
                            [attr.aria-label]="'Toggle ' + node.name"
                        >
                            <mat-icon class="mat-icon-rtl-mirror">
                                {{
                                    treeControl.isExpanded(node)
                                        ? "expand_more"
                                        : "chevron_right"
                                }}
                            </mat-icon>
                        </button>
                        <span style="font-weight: bold; margin-right: 5px">{{
                            node.name
                        }}</span>
                        <span
                            *ngIf="
                                node.descripcion != null &&
                                node.descripcion != ''
                            "
                            style="margin-right: 5px"
                        >
                            | {{ node.descripcion }}</span
                        >
                        <span
                            *ngIf="
                                node.opcion != null && node.opcion?.nombre != ''
                            "
                            style="margin-right: 5px"
                        >
                            | {{ node.opcion?.nombre }}</span
                        >
                        <span
                            *ngIf="node.tipo != null && node.tipo != ''"
                            style="margin-right: 5px"
                        >
                            | {{ node.tipo }}</span
                        >
                        <!--
            <span *ngIf="node.palabrasClave!=null && node.palabrasClave.length>0" style="font-weight: bold;margin-right:5px;"> | </span>
            <mat-chip-list aria-label="Palabras Clave" *ngIf="node.palabrasClave!=null && node.palabrasClave.length>0">
              <mat-chip *ngFor="let palabra of node.palabrasClave">{{palabra}}</mat-chip>
            </mat-chip-list>-->
                    </mat-tree-node>
                </mat-tree>
            </div>

            <div fxFlex="100" fxLayoutAlign="end end" class="p-24">
                <button
                    mat-button
                    (click)="closeDialog()"
                    mat-flat-button
                    color="warn"
                >
                    {{ "Cancel" | translate }}
                </button>
                <button mat-button matStepperPrevious>Anterior</button>
                <button mat-button (click)="doAction()" *ngIf="action == 'Add'">
                    Grabar
                </button>
                <button
                    mat-button
                    (click)="doAction()"
                    *ngIf="action != 'View' && action != 'Add'"
                >
                    {{ action | translate }}
                </button>
            </div>
        </mat-step>
    </mat-horizontal-stepper>
</div>
<div mat-dialog-actions fx-layout="row" fx-flex fxLayoutAlign="end center">
    <button mat-button (click)="doAction()" *ngIf="action == 'Delete'">
        {{ action | translate }}
    </button>
    <button
        mat-button
        mat-dialog-close
        mat-flat-button
        color="warn"
        *ngIf="action == 'View' || action == 'Delete'"
    >
        {{ "Cancel" | translate }}
    </button>
</div>
